import { Injectable } from '@angular/core';
import { EnvironmentService } from '@digiwall/goliath-core';
import { OAuthService } from 'angular-oauth2-oidc';
import * as signalR from '@microsoft/signalr';
import { Observable, Subscriber } from 'rxjs';

export enum DocumentSigningStatus {
  NotStarted,
  InProgress,
  Completed,
  Cancelled,
}

@Injectable()
export class CustomerDeliveryNoteSigningHubService {
  private _hubConnection: signalR.HubConnection;

  constructor(
    environment: EnvironmentService,
    private _authService: OAuthService,
  ) {
    this._hubConnection = new signalR.HubConnectionBuilder()
      .withUrl(environment.getApiUrl('default') + '/signalr-hubs/customer-delivery-note-signing', {
        accessTokenFactory: () => this._authService.getAccessToken(),
      })
      .withAutomaticReconnect()
      .build();
  }

  endConnection(): void {
    if (
      this._hubConnection.state != signalR.HubConnectionState.Disconnected &&
      this._hubConnection.state != signalR.HubConnectionState.Disconnecting
    ) {
      this._hubConnection.stop();
    }
  }

  startConnection(signingKey: string): Observable<void> {
    return new Observable<void>(observer => {
      this.startHubConnection(signingKey, observer);
    });
  }

  private startHubConnection(signingKey: string, observer: Subscriber<void>) {
    this._hubConnection
      .start()
      .then(() => {
        this._hubConnection.invoke('SubscribeAsync', signingKey);
        observer.next();
        observer.complete();
      })
      .catch(error => {
        console.error('Error connecting to SignalR hub:', error);
        observer.error(error);
      });
  }

  requestStateChanged(): Observable<DocumentSigningStatus> {
    return new Observable<DocumentSigningStatus>(observer => {
      this._hubConnection.on('RequestStateChangedAsync', (state: DocumentSigningStatus) => {
        observer.next(state);
      });
    });
  }
}
